// Анкета «Подарок за подписку» в Telegram (до 01.09.2026 звалась «Проверка подписки в
// Telegram»). Шаги, вид и порядок — ОДИН В ОДИН с инстаграмным «Подарком за подписку»
// (владелец 01.09.2026: прежний мастер был беден — три длинных шага вместо семи).
// Суть шаблона прежняя: бот здоровается, проверяет подписку на канал и отдаёт
// обещанное. Свой полный список запусков Телеграма — на шаге «Что запускает».
// Дефолтные тексты сообщений уезжают в бота
// клиента и берутся по языку кабинета в момент создания (TXT ниже): создал бота из
// английского кабинета — бот пишет людям по-английски (владелец 2026-08-06).
// Сборка — патчи канона шаблона hotcat:3-tg-subscription-check (структура: Старт →
// метка? → приветствие с кнопками → подписан? → выдача ссылки → задержка → догрев).
import {
  blankCondRow,
  tgSubscribedExpr,
  plainToTgHtml,
  TG_MESSAGE_NODE_TYPE,
  type ChatAttachKind,
  type ChatCondRow,
  type WorkflowJson,
  type WorkflowNode,
} from '@scriptera/ui/scenario';
import {
  htmlToPlain,
  legacyFileMedia,
  legacyWizardToBundle,
  toTgDraft,
  type TgDraft,
  type TgMessageBundle,
} from '@scriptera/db/tg-message';
import { letterBundleOf } from '../tg-letter-bundle';
import {
  ansBool,
  ansGift,
  ansNum,
  ansStr,
  wfConnect,
  wfDropNodes,
  wfGotGate,
  wfInsertAfter,
  wfInsertBefore,
  wfRenameNode,
  wfSetNotes,
  wfSetOuts,
  wfSetParams,
  wfSetType,
  wfUnsetParams,
  wizMsgRow,
  wizGiftFileParam,
  wizEntryWords,
  wizGiftKindParam,
  wizFileName,
  WIZ_GIFT_FILE,
  wizNodeTitle,
  wizSwitchParams,
  type WizEntryAt,
  type WizPill,
  WIZ_GIFT_KIND,
  WIZ_GIFT_LINK,
  type TemplateWizardDef,
  type WizardBuildExtras,
  type WizardGift,
  type WizardLocale,
  type WizardPreviewMsg,
  aboutStep,
  EXTRA_TEXT_SAMPLE,
  EXTRA_TEXT_TOGGLE,
} from './core';
import type { BotEntry } from '@scriptera/db/bot-entries';
import { SCENE_NO_FILE, type SceneTexts } from '@/lib/wizard-scene-texts';
// ШАГ «ЧТО ЗАПУСКАЕТ» — ОДИН И ТОТ ЖЕ У ЦЕПОЧКИ И У БОТОВ (К18.1 п.9–10): строит его
// общий модуль, список триггеров живёт ответом `entries` (`BotEntry[]`).
import {
  botTrigChat,
  botTrigStore,
  tgLegacyEntries,
  trigBlocked,
  triggerStep,
} from './trigger-step';

/** Ключ шага «Что запускает» (по нему stepBlocked узнаёт, что сейчас на экране). */
const TG_ENTRY_STEP = 'entry';

/** Ключ шага «Бот» — на нём стоят тумблер «Проверить подписку» и поле «Канал». */
const TG_BOT_STEP = 'account';

/**
 * ОТКАЗЫ ЖИВОЙ ПРОВЕРКИ КАНАЛА, КОТОРЫЕ ДЕРЖАТ «ДАЛЬШЕ» (ТЗ 19.09.2026 Р4).
 *
 * INVARIANT(scriptera): 'network' сюда НЕ входит. Причина: «Телеграм сейчас не ответил» —
 * это про связь, а не про канал, и запирать человека из-за чужого сбоя нельзя; красная
 * строка у поля при этом стоит, а последним сторожем остаётся линт запуска. Остальные
 * причины — ответ площадки про САМ канал, и он не изменится от нажатия «Дальше».
 * Канон: docs/NATIVE-WIZARD-PLAN.md, ТЗ 19.09.2026, решение Р4.
 */
const CHAN_HOLD: ReadonlySet<string> = new Set([
  'badAddress',
  'notFound',
  'notMember',
  'notAdmin',
  'notChannel',
  'botDead',
]);

/** Старые черновики (галочки `entryKinds` + плоские слова) открывает АДАПТЕР. */
const store = botTrigStore('tg', tgLegacyEntries);

// Имена узлов шаблона (истина — канон в bot_templates; сверка — check-скрипт Ф3.2).
const N = {
  start: 'Старт',
  condTag: 'Условие: Метка: прошёл воронку',
  // Ветка «уже проходил воронку» канона: мастер её ВЫБРАСЫВАЕТ (владелец 20.09.2026 —
  // материал отдаётся заново, отговорки «мы уже общались» у бота нет). Имя нужно, чтобы
  // было что выбросить.
  repeat: 'Мы уже общались Всё, что я отправлял,',
  welcome: 'Привет! Дарю подборку «50 идей для пос',
  welcomeSwitch: 'Какую кнопку нажал?',
  wait10: 'Без ответа 10 мин',
  remindMsg: 'Ты ещё тут? Подборка ждёт — кнопка выш',
  condSub: 'Условие: Подписан',
  noSub: 'Пока не вижу подписки на канал Подпиши',
  noSubSwitch: 'Какую кнопку нажал? (2)',
  setTag: 'Записать: метка + прошёл воронку',
  link: 'Лови! Пользуйся на здоровье',
  wait15: 'Задержка 15 мин',
  extraMsg: 'Кстати, если хочешь [следующая ценность]',
} as const;

// Тексты СОБРАННОГО бота под язык кабинета (владелец 2026-08-06: «создал бота из
// английского кабинета — всё по-английски, и реплики тоже»): заготовки полей анкеты,
// запасные значения сборки и подписи узлов готовой схемы. Русские — дефолты ChatPlace
// из выгрузки мастера, без эмодзи (правило владельца 31.07).
// ВАЖНО: язык выбирается ОДИН РАЗ, в момент создания бота, и запекается в черновик
// (wizard.locale) — смена языка кабинета потом реплики уже созданного бота не трогает.
const TXT = {
  ru: {
    welcome: 'Привет! Хочешь получить урок по настройке чат-ботов?',
    welcomeBtn: 'Да, хочу',
    link: 'Отлично! Нажимай на кнопку ниже, чтобы открыть материал.',
    linkBtn: 'Смотреть уроки',
    remind: 'Прошло 10 минут, а я все жду, когда ты нажмешь на кнопку выше, чтобы получить ссылку на урок.',
    noSub: 'Пока не вижу подписки на канал. Подпишись и нажми ещё раз.',
    noSubBtn: 'Готово',
    channelBtn: 'Перейти в канал',
    linkStub: '[ссылка]',
    // Развилка входящего при проверке подписки: подписи выходов, имя и заметка узла.
    outBtn: 'Нажал кнопку',
    outWord: 'Кодовое слово',
    outStart: 'Начало разговора',
    outOther: 'Любое другое сообщение',
    nEntry: 'Что написал пользователь?',
    noteEntry:
      'Что пришло от пользователя: нажал кнопку бота — идём дальше по ветке кнопки, ' +
      'начало разговора ведёт к приветствию, ' +
      'а любое другое сообщение — к повторной проверке подписки. ' +
      'Так пользователь не застревает, даже если кнопка ему не показалась: он просто пишет словами',
    // Метка человека, забравшего подарок: по ней считается «дошёл до цели» и по ней же
    // напоминание обходит тех, кто уже всё получил.
    giftTag: 'получил подарок',
    nRemember: 'Запомнить контакт',
    noteRemember:
      'Бот записывает пользователя в вашу базу подписчиков: имя и логин берутся из Телеграма. ' +
      'Дальше по этой карточке считаются метки и работают рассылки',
    nGotTag: 'Метка: получил подарок',
    noteGotTag:
      'Ставим пользователю метку «получил подарок»: по ней видно, кто дошёл до конца, ' +
      'и по ней же бот не напоминает тем, кто уже всё забрал',
    nGotCheck: 'Уже получил?',
    noteGotCheck: 'Смотрим в карточке пользователя, забирал ли он подарок',
    nGotIf: 'Подарок уже получил?',
    // Подписи узлов собранной схемы (их человек видит в схеме бота).
    nWelcome: 'Приветствие',
    nNoSub: 'Если нет подписки',
    nLink: 'Сообщение со ссылкой',
    nRemind: 'Напоминание',
    nDelay: 'Задержка',
    nDelayMin: (m: number) => `Задержка ${m} мин`,
    nExtra: 'Дополнительное сообщение',
    nPhoto: 'Картинка к приветствию',
    // Шаг проверки подписки: его имя стоит в формуле условия — менять нельзя, не
    // поправив формулу (переименование узлов формулы не трогает, см. wfRenameNode).
    nSubCheck: 'Проверка подписки',
    noteSubCheck:
      'Бот спрашивает у Телеграма, подписан ли пользователь на ваш канал. ' +
      'Чтобы ответ приходил, бот должен быть администратором этого канала',
  },
  en: {
    welcome: 'Hi! Would you like a lesson on setting up chat-bots?',
    welcomeBtn: 'Yes, please',
    link: 'Great! Tap the button below to open the material.',
    linkBtn: 'Watch the lessons',
    remind: 'Ten minutes have passed and I am still waiting for you to tap the button above and get the link to the lesson.',
    noSub: 'I do not see your subscription to the channel yet. Subscribe and tap again.',
    noSubBtn: 'Done',
    channelBtn: 'Open channel',
    linkStub: '[link]',
    outBtn: 'Tapped a button',
    outWord: 'Code word',
    outStart: 'Start of the chat',
    outOther: 'Any other message',
    nEntry: 'What did the user write?',
    noteEntry:
      'What the user sent: a tap on a bot button follows the button branch, ' +
      'the start of the chat leads to the welcome message, ' +
      'while any other message goes to a fresh subscription check. ' +
      'So nobody gets stuck when the button is not shown to them — they can just write words',
    giftTag: 'got the gift',
    nRemember: 'Remember the contact',
    noteRemember:
      'The bot saves the user into your subscriber base: name and handle come from Telegram. ' +
      'Tags and broadcasts work off that card later',
    nGotTag: 'Tag: got the gift',
    noteGotTag:
      'We tag the user as “got the gift”: it shows who made it to the end, ' +
      'and it keeps the reminder away from those who already have everything',
    nGotCheck: 'Already got it?',
    noteGotCheck: 'We look at the user card to see whether they already took the gift',
    nGotIf: 'Already got the gift?',
    nWelcome: 'Welcome',
    nNoSub: 'If not subscribed',
    nLink: 'Message with the link',
    nRemind: 'Reminder',
    nDelay: 'Delay',
    nDelayMin: (m: number) => `Delay ${m} min`,
    nExtra: 'Follow-up message',
    nPhoto: 'Welcome image',
    nSubCheck: 'Subscription check',
    noteSubCheck:
      'The bot asks Telegram whether the user is subscribed to your channel. ' +
      'For the answer to arrive, the bot must be an administrator of that channel',
  },
} as const satisfies Record<WizardLocale, Record<string, unknown>>;

/**
 * ВТОРАЯ ПАРА «Уже получил?» — НА ЗАПАСНОМ ВЫХОДЕ РАЗВИЛКИ ВХОДЯЩЕГО (владелец 16.10.2026).
 * Слова — те же, что у пары напоминания (новых строк нет); имена узлов — с суффиксом,
 * чтобы в схеме не спутать с ней. Ими же собирает свою пару инста-анкета (ig-wizard.ts).
 */
export function gotGateTexts(locale: WizardLocale): { nCheck: string; noteCheck: string; nIf: string } {
  const T = TXT[locale];
  return { nCheck: `${T.nGotCheck} (2)`, noteCheck: T.noteGotCheck, nIf: `${T.nGotIf} (2)` };
}

// ЖИВОЙ АДРЕС СОБЕСЕДНИКА — И НА ПИСЬМЕ, И НА НАЖАТИИ КНОПКИ (К26.2 п.1, аудит 08.09).
// Нажатие inline-кнопки приходит апдейтом `callback_query`, у которого поля `message`
// наверху НЕТ ВОВСЕ: прежнее `message.chat.id` давало undefined, узел падал и прогон
// гиб — подарок по кнопке не выдавался никому. Читаем оба места по очереди и всюду
// через «?.»: обращение без оговорки роняет шаг вместо тихого пропуска.
const START_JSON = `$('${N.start}').first().json`;

/** Чат, куда бот отвечает: письмо человека или его же нажатие кнопки. */
const CHAT_ID = `={{ ${START_JSON}.message?.chat?.id ?? ${START_JSON}.callback_query?.message?.chat?.id }}`;

/** Кто этот человек для Телеграма (проверка подписки спрашивает про него). */
const FROM_ID = `={{ ${START_JSON}.message?.from?.id ?? ${START_JSON}.callback_query?.from?.id }}`;

/** Поле профиля человека из письма или из нажатия кнопки (для карточки контакта). */
const fromField = (name: string): string =>
  `${START_JSON}.message?.from?.${name} ?? ${START_JSON}.callback_query?.from?.${name}`;

/** Имя человека из профиля Телеграма: «Имя Фамилия», пустых кусков не остаётся. */
const NAME_EXPR = `={{ [${fromField('first_name')}, ${fromField('last_name')}].filter(Boolean).join(' ') }}`;

/** Логин человека (@ник) — тем же приёмом. */
const USERNAME_EXPR = `={{ ${fromField('username')} }}`;

// ПРИСТАВКИ callback_data КНОПОК СЦЕНАРИЯ (их ставит inlineKeyboard по buttonPrefix):
// приветствие — `t-welcome-btn-<N>`, «если нет подписки» — `t-nosub-btn-<N>`. По ним
// развилка входящего узнаёт НАЖАТИЕ, и менять их нельзя — они уже стоят у всех
// собранных ботов (замок в тестах).
const BTN_PREFIX = ['t-welcome-btn', 't-nosub-btn'] as const;

/**
 * ПИСЬМО ШАБЛОНА ОДНОЙ МОДЕЛЬЮ (MESSAGE-COMPOSER Б2). Тексты анкеты — это по-прежнему
 * тройка «текст / подпись кнопки / картинка»; в общую модель их приводит адаптер, а
 * кнопок у шаблона бывает две (своя и ссылка в канал), поэтому клавиатура дописывается
 * тем же правилом: адрес есть — кнопка-ссылка, нет — кнопка, нажатие которой ловим мы.
 */
function wizBundle(
  text: string,
  buttons: Array<{ text: string; url?: string }> = [],
  /** Картинка ТЕМ ЖЕ сообщением (владелец 20.09.2026): фото, текст подписью, кнопки под
   *  ним — как шлёт любой бот Телеграма (sendPhoto + caption + reply_markup). Текст длиннее
   *  подписи (1024) splitBundle сам разнесёт: фото, затем текст с кнопками. Ссылка — наш
   *  файл (`/api/form/file/<id>?name=…`), отправитель читает его по id (tg-letter readMedia). */
  image?: string,
  /** Вложение подарка (ролик, звук, документ, картинка) ТЕМ ЖЕ сообщением — текст его
   *  подписью (владелец 20.09.2026: «текст с видео отдать одним сообщением»). Длинный
   *  текст splitBundle разнесёт сам: вложение, затем текст. */
  attach?: { kind: 'image' | 'video' | 'audio' | 'file'; url: string },
): TgMessageBundle {
  const draft = legacyWizardToBundle({ text: plainToTgHtml(text), ...(image ? { image } : {}) });
  return letterBundleOf({
    // Текст анкеты обычный, а письмо уходит с разметкой Телеграма: экранируем, иначе
    // одиночная «<» или «&» в тексте клиента валит отправку.
    ...draft,
    ...(attach && attach.url ? { media: [legacyFileMedia(attach.url, attach.kind)] } : {}),
    buttons: buttons
      .filter((b) => b.text.trim() !== '')
      .map((b) => [
        b.url
          ? { text: b.text, kind: 'url' as const, url: b.url }
          : { text: b.text, kind: 'tag' as const, tag: b.text },
      ]),
  });
}

/**
 * ЧЕРНОВИК ЭПОХИ ОКНА «СООБЩЕНИЕ» → ПЛОСКИЕ ОТВЕТЫ (К23.1 п.1, владелец 07.09.2026:
 * «то окно предназначено только для цепочки… сюда верни тот именно вид, который есть в
 * Инстаграме, один в один»).
 *
 * С 03.09 по 07.09.2026 сообщения этой анкеты собирались окном «Сообщение» и лежали
 * строкой JSON в своих ответах (`welcomeMsg` и сёстры, коммит 337eec117). Форма полей
 * вернулась, и такие ответы читаются АДАПТЕРОМ — один раз, при открытии анкеты и при
 * сборке: текст, своя кнопка и вложение переезжают в прежние поля, а связка из ответов
 * уходит. Назад пишется только плоское: второго места, где живёт сообщение, снова нет.
 */
const OLD_MSG = ['welcomeMsg', 'noSubMsg', 'giftMsg', 'remindMsg', 'extraMsg'] as const;

/** Вид медиа письма → вид вложения анкеты (у анкеты их четыре, у письма семь). */
const MEDIA_GIFT: Record<string, ChatAttachKind> = {
  photo: 'image',
  animation: 'image',
  video: 'video',
  round: 'video',
  audio: 'audio',
  voice: 'audio',
  document: 'file',
};

/** Письмо из ответа-связки; нет связки или она битая — null (тогда поля и так плоские). */
function oldDraft(a: Record<string, unknown>, key: string): TgDraft | null {
  const raw = ansStr(a, key, 200_000);
  if (raw === '') return null;
  try {
    return toTgDraft(JSON.parse(raw));
  } catch {
    return null;
  }
}

/**
 * ОТВЕТЫ АНКЕТЫ ПЛОСКИМИ ПОЛЯМИ. Связок нет — возвращаем то же, что дали (обычный
 * случай). Есть — раскладываем их по прежним полям и связки выбрасываем.
 *
 * Голосовое, кружок и второе вложение приветствия в плоскую форму не переносятся: полей
 * под них у анкеты Instagram нет, а заводить новые ТЗ не велит (решение исполнителя,
 * К23.3 этап 1 п.1). Подписи кнопок `welcomeBtn`/`noSubBtn` в письмо никогда не клались
 * (они были приколотыми) — они всё это время лежали плоско и не теряются.
 */
export function tgFlatAnswers(src: Record<string, unknown>): Record<string, unknown> {
  if (!OLD_MSG.some((key) => ansStr(src, key, 200_000) !== '')) return src;
  const out: Record<string, unknown> = { ...src };
  for (const key of OLD_MSG) delete out[key];
  const put = (name: string, value: string): void => {
    if (value.trim() !== '') out[name] = value;
  };
  const welcome = oldDraft(src, 'welcomeMsg');
  if (welcome) {
    put('welcomeText', htmlToPlain(welcome.text));
    const img = welcome.media.find((m) => MEDIA_GIFT[m.kind] === 'image');
    if (img) out.welcomeImage = img.id;
  }
  const noSub = oldDraft(src, 'noSubMsg');
  if (noSub) put('noSubText', htmlToPlain(noSub.text));
  const gift = oldDraft(src, 'giftMsg');
  if (gift) {
    put('linkText', htmlToPlain(gift.text));
    const media = gift.media[0];
    const kind = media ? MEDIA_GIFT[media.kind] : undefined;
    if (media && kind) {
      out[WIZ_GIFT_KIND] = kind;
      out[WIZ_GIFT_FILE] = media.id;
    }
    // Своя кнопка письма бывала одна — та самая кнопка-ссылка выдачи.
    const btn = gift.buttons.flat()[0];
    if (btn && btn.kind === 'url') {
      put('linkBtn', btn.text);
      put('linkUrl', btn.url);
    }
  }
  const remind = oldDraft(src, 'remindMsg');
  if (remind) put('remindText', htmlToPlain(remind.text));
  const extra = oldDraft(src, 'extraMsg');
  if (extra) put('extraText', htmlToPlain(extra.text));
  return out;
}

/**
 * ПОСТАВИТЬ НА МЕСТО ШАГА-СООБЩЕНИЯ НАШ УЗЕЛ (MESSAGE-COMPOSER Б6). Имя, id, связи и
 * место на холсте остаются — меняется только то, ЧЕМ уходит сообщение: у штатного узла
 * Телеграма нет ни голосового, ни кружка, а окно «Сообщение» (Г5) даст шаблону и то и
 * другое.
 *
 * `buttonPrefix` сохраняет ПРЕЖНИЕ `callback_data` шаблона (`t-welcome-btn-0`): по ним
 * развилка «какую кнопку нажал» узнаёт нажатие, и трогать её незачем.
 */
function wfTgMessage(
  wf: WorkflowJson,
  name: string,
  bundle: TgMessageBundle,
  buttonPrefix?: string,
): WorkflowJson {
  let out = wfSetType(wf, name, TG_MESSAGE_NODE_TYPE, 1);
  out = wfUnsetParams(out, name, [
    'resource',
    'operation',
    'text',
    'replyMarkup',
    'inlineKeyboard',
    'replyKeyboard',
    'additionalFields',
  ]);
  return wfSetParams(out, name, {
    chatId: CHAT_ID,
    message: JSON.stringify(bundle),
    ...(buttonPrefix ? { buttonPrefix } : {}),
  });
}

// Откуда развилка берёт текст входящего. Путь собирает общее ядро (msgTextAt): у
// Телеграма он идёт через «?.» — нажатие inline-кнопки приходит апдейтом callback_query,
// у которого поля message наверху нет вовсе, и обращение к .text без оговорки уронило бы
// шаг вместо тихого ухода в запасной выход.
const AT: WizEntryAt = { startName: N.start, channel: 'telegram' };

/** Пилюля развилки «что написал человек»: узнали ли во входящем начало разговора.
 *  Одна на обе ветки анкеты (с проверкой подписки и без) — разъехавшись, они дали бы
 *  двух разных ботов на один и тот же выбор в анкете.
 *
 *  ВХОДОВ ТЕПЕРЬ СПИСОК (ТЗ 02.09 §6): по ряду на каждый отмеченный вход, сшитые «или».
 *  «Команда /start» и «Переход по ссылке» приходят командой «Старт» (см. triggerMeta):
 *  она и есть начало разговора; после команды бывает хвост-приглашение («/start ref123»),
 *  поэтому «начинается с», а не «равно». «Любое сообщение» узнаётся тем же «/start»: до
 *  01.09.2026 этот вариант вёл себя РОВНО как команда «Старт» (см. историю выше), и
 *  внутри сценария поведение не меняется — новое у него только то, что диспетчер отдаёт
 *  боту и другие сообщения. Всё, что пилюле не подошло, уходит запасным выходом:
 *  с проверкой подписки — на проверку, без неё — репликой вернувшемуся.
 */
function entryPill(a: Answers, T: (typeof TXT)['ru' | 'en']): WizPill {
  const rows: ChatCondRow[] = [];
  const seen = new Set<string>();
  const add = (op: ChatCondRow['op'], value: string) => {
    const word = value.trim();
    if (!word || seen.has(`${op}|${word.toLowerCase()}`)) return;
    seen.add(`${op}|${word.toLowerCase()}`);
    rows.push(wizMsgRow(`c-check-entry-${rows.length}`, AT, word, op));
  };
  // «ЛЮБОЕ СООБЩЕНИЕ» (приказ владельца 02.09, исправление координатора при слиянии):
  // приветствие получает ВСЁ, что написал человек, кроме подписей кнопок бота — их
  // разбирает запасной выход (проверка подписки / реплика вернувшемуся). Узнавать
  // «любое» по «/start» нельзя: на «привет» бот не здоровался бы вовсе. Ряды «не равно
  // кнопке» связаны «и» — поэтому этот вход собирается один, без прочих: любое и так
  // покрывает и слово, и /start.
  if (a.entries.some((e) => e.kind === 'any')) {
    const buttons = [a.welcomeBtn, ...(a.checkSub ? [a.noSubBtn] : [])].map((b) => b.trim()).filter(Boolean);
    const notButtons = buttons.map((b, i) => wizMsgRow(`c-check-entry-${i}`, AT, b, 'ne'));
    if (notButtons.length === 0) notButtons.push(wizMsgRow('c-check-entry-0', AT, '', 'ne'));
    return { outputKey: T.outStart, group: { rows: notButtons, any: false } };
  }
  for (const e of a.entries) {
    if (e.kind === 'exact') for (const w of e.keywords) add('eq', w);
    else if (e.kind === 'keyword') for (const w of e.keywords) add('contains', w);
    else add('startsWith', '/start');
  }
  // Отмечены только слова, а слов не вписали — начало разговора узнаём по «/start»
  // (пустая развилка отправляла бы к приветствию вообще всех).
  if (rows.length === 0) add('startsWith', '/start');
  const onlyWords = rows.every((r) => r.op !== 'startsWith');
  return { outputKey: onlyWords ? T.outWord : T.outStart, group: { rows, any: true } };
}

/**
 * ПЕРВАЯ ПИЛЮЛЯ РАЗВИЛКИ ВХОДЯЩЕГО — «нажал кнопку бота» (К26.2 п.2, аудит 08.09).
 *
 * Нажатие приходит НОВЫМ запуском сценария (апдейтом `callback_query`), и до 08.09 его
 * не узнавал никто: развилки «Какую кнопку нажал?» смотрели в `$json.pressedButton`,
 * которого не пишет ни один наш узел, — подарок по кнопке не выдавался вовсе.
 * Узнаём нажатие по приставке `callback_data`, которую ставит наш же отправитель.
 *
 * ПОРЯДОК ПИЛЮЛЬ ОБЯЗАТЕЛЕН: эта — ПЕРВАЯ. У входа «любое сообщение» ряды «не равно
 * подписи кнопки» на пустом тексте колбэка проходят, и нажатие ушло бы к приветствию.
 */
function pressPill(T: (typeof TXT)['ru' | 'en']): WizPill {
  return {
    outputKey: T.outBtn,
    group: {
      rows: BTN_PREFIX.map((prefix, i) => ({
        ...blankCondRow('raw', `c-check-btn-${i}`),
        expr: `String(${START_JSON}.callback_query?.data || '').startsWith('${prefix}')`,
      })),
      any: true,
    },
  };
}

/** Шаг «Контакты» собранной схемы: формы — те же, что у инстаграмных анкет (К26.1). */
function contactNode(
  id: string,
  name: string,
  notes: string,
  params: Record<string, unknown>,
): WorkflowNode {
  return {
    id,
    name,
    type: 'CUSTOM.scripteraContacts',
    typeVersion: 1,
    position: [0, 0],
    notes,
    parameters: { source: 'manual', channel: 'telegram', externalId: CHAT_ID, ...params },
  };
}

/**
 * Канал из анкеты → адрес, который принимает Телеграм при проверке подписки: «@логин»
 * или числовой id вида -100…. Человек пишет как привык — ссылкой t.me, с собакой и без,
 * иногда с хвостом после слэша, — а площадка такие формы не понимает и отвечает отказом
 * на каждую проверку.
 *
 * Личная ссылка-приглашение (t.me/+hash, joinchat) адресом канала быть не может вовсе:
 * отдаём пусто, и линт схемы скажет человеку обычными словами «не выбран канал» —
 * это его поле и он его поправит (запрет №7: чужие косяки клиенту не показываем, свои —
 * показываем словами).
 */
function tgChatId(link: string): string {
  const raw = link.trim();
  if (raw === '') return '';
  if (/^-?\d+$/.test(raw)) return raw;
  const path = raw
    .replace(/^https?:\/\//i, '')
    .replace(/^(?:www\.)?(?:t\.me|telegram\.me)\//i, '')
    .replace(/^s\//i, '');
  if (/^(?:\+|joinchat\/)/i.test(path)) return '';
  const name = (path.replace(/^@/, '').split(/[/?#]/)[0] ?? '').trim();
  return /^[A-Za-z0-9_]{4,}$/.test(name) ? `@${name}` : '';
}

export interface TgGiftAnswers {
  checkSub: boolean;
  channelLink: string;
  /** Триггеры бота СПИСКОМ (К18.3 этап 2 п.1): порядок — порядок списка у человека. */
  entries: BotEntry[];
  welcomeText: string;
  welcomeBtn: string;
  welcomeImage: string;
  noSubText: string;
  noSubBtn: string;
  linkText: string;
  linkBtn: string;
  linkUrl: string;
  /** Что уходит вместе с сообщением: ссылка кнопкой (как было) или ОДНО вложение. */
  gift: WizardGift;
  remind: boolean;
  remindText: string;
  extra: boolean;
  extraText: string;
  extraMinutes: number;
  /** Через сколько часов молчания бот отпускает человека (замок диалога, Л1 п.5). */
  finishHours: number;
  /** «Не запускать повторно» (Л5.1 п.1) и срок запрета в ДНЯХ. */
  noRepeat: boolean;
  noRepeatDays: number;
}

type Answers = TgGiftAnswers;

/** Ответы анкеты, прочитанные так же, как их читает сборка бота (их же показывает страница бота клиента в Scriptera A,
 *  lib/adm/bot-view.ts — второго разбора ответов нет). */
export function readTgGiftAnswers(raw: Record<string, unknown>, locale: WizardLocale): TgGiftAnswers {
  return readAnswers(raw, locale);
}

function readAnswers(raw: Record<string, unknown>, locale: WizardLocale): Answers {
  const T = TXT[locale];
  // ОТВЕТЫ ВСЕГДА ПЛОСКИЕ (К23.1 п.1): черновик, сохранённый окном «Сообщение»
  // (03.09–07.09.2026), раскладывает адаптер — и здесь, и при открытии анкеты.
  const a = tgFlatAnswers(raw);
  const extraText = ansStr(a, 'extraText', 500);
  return {
    checkSub: ansBool(a, 'checkSub', true),
    channelLink: ansStr(a, 'channelLink', 300),
    entries: store.read(a),
    welcomeText: ansStr(a, 'welcomeText', 500, T.welcome),
    welcomeBtn: ansStr(a, 'welcomeBtn', 20, T.welcomeBtn),
    welcomeImage: ansStr(a, 'welcomeImage', 500),
    noSubText: ansStr(a, 'noSubText', 500, T.noSub),
    noSubBtn: ansStr(a, 'noSubBtn', 20, T.noSubBtn),
    linkText: ansStr(a, 'linkText', 500, T.link),
    linkBtn: ansStr(a, 'linkBtn', 20, T.linkBtn),
    linkUrl: ansStr(a, 'linkUrl', 500),
    gift: ansGift(a, 'telegram'),
    remind: ansBool(a, 'remind'),
    remindText: ansStr(a, 'remindText', 500, T.remind),
    // Пустое доп. сообщение = выключено (как невключённый тумблер).
    extra: ansBool(a, 'extra') && extraText !== '',
    extraText,
    extraMinutes: ansNum(a, 'extraMinutes', { min: 1, max: 10080, fallback: 10 }),
    finishHours: ansNum(a, 'finishHours', { min: 1, max: 720, fallback: 24 }),
    noRepeat: ansBool(a, 'noRepeat'),
    noRepeatDays: ansNum(a, 'noRepeatDays', { min: 1, max: 365, fallback: 30 }),
  };
}

/** ПЕРВАЯ ФРАЗА ТЕКСТА — для карточки «что умеет бот» на телеграмной заставке: всё
 *  приветствие туда не влезет, а первое предложение как раз говорит, зачем бот. Длинную
 *  фразу режем по слову многоточием. */
function firstSentence(text: string, max = 160): string {
  const one = text.trim().replace(/\s+/g, ' ');
  if (!one) return '';
  const cut = (/^[^.!?]+[.!?]/.exec(one)?.[0] ?? one).trim();
  return cut.length <= max ? cut : `${cut.slice(0, max - 1).replace(/[\s,.;:—-]+\S*$/, '')}…`;
}

/**
 * ЗАГОТОВКИ «СООБЩЕНИЯ» ПОДАРКА ПО ВИДУ МАТЕРИАЛА (владелец 20.09.2026: «каталоги текстов
 * не универсальны — „нажимай на кнопку" под видео»). Сменил «Что отправить» — поле получает
 * заготовку под новый вид, если человек его не правил (core.ts, WizardKindText).
 */
export const GIFT_TEXTS: Record<string, Record<WizardLocale, string>> = {
  link: { ru: TXT.ru.link, en: TXT.en.link },
  image: { ru: 'Отлично! Вот обещанная картинка.', en: 'Great! Here is the picture I promised.' },
  video: { ru: 'Отлично! Вот обещанное видео.', en: 'Great! Here is the video I promised.' },
  audio: { ru: 'Отлично! Вот обещанная аудиозапись.', en: 'Great! Here is the audio I promised.' },
  file: { ru: 'Отлично! Вот обещанный файл.', en: 'Great! Here is the file I promised.' },
};

export const subscribeCheckTg: TemplateWizardDef = {
  id: 'subscribe-check-tg',
  kindTexts: [{ select: WIZ_GIFT_KIND, field: 'linkText', text: GIFT_TEXTS }],
  // ФРАЗА ПО ГАЛОЧКЕ (владелец 20.09.2026, механика ChatPlace): включили «Проверить
  // подписку» — в поле приветствия дописывается условие, выключили — убирается; поле
  // правится как угодно (core.ts applyToggleTexts).
  toggleTexts: [
    // «Дополнительное сообщение» включили, а поле пустое — пример (ТЗ USERTEST-1014 п.8).
    EXTRA_TEXT_TOGGLE,
    {
      toggle: 'checkSub',
      field: 'welcomeText',
      text: {
        ru: 'Чтобы получить материал, подпишись на канал и нажми кнопку.',
        en: 'To get the material, subscribe to the channel and tap the button.',
      },
    },
  ],
  templateSource: 'hotcat:3-tg-subscription-check',
  // Семейства нет (владелец 2026-08-06, Ш2): анкета телеграмная — только ТГ-боты и один
  // значок сети. Связка с инста-сестрой отменена вместе с ней.
  // Ф2: аккаунт — первым вопросом (копия ChatPlace); варианты подставляет панель,
  // выбранный бот сервер проставляет в узлы канона при создании и пересборке.
  accountChannel: 'telegram',

  // ЗНАКОМСТВО — первый экран анкеты (ТЗ-2 З1): описание про весь сценарий.
  // Чат на первом экране — сцена «Подарок за подписку» в Телеграме (ТЗ-3 Т1): тот же
  // сюжет, что у инстаграмного подарка, в оформлении Телеграма.
  // ВРЕМЕННО ДЛЯ СЪЁМКИ РОЛИКА (владелец 22.09.2026): после съёмки вернуть 's4'.
  demoScene: 's4',

  lead(locale: WizardLocale) {
    const ru = locale === 'ru';
    return {
      title: ru ? 'Подарок за подписку' : 'Gift for a follow',
      text: ru
        ? 'Пользователь запускает бота, бот приветствует его, при необходимости проверяет подписку на ваш канал и отправляет обещанный материал: ссылку, файл или промокод.'
        : 'The user starts the bot, the bot greets them, checks the channel subscription if required and sends the promised material: a link, a file or a promo code.',
    };
  },

  // ШАГИ — ОДИН В ОДИН С ИНСТАГРАМНЫМ «ПОДАРКОМ ЗА ПОДПИСКУ» (владелец 01.09.2026:
  // «переделать под тот же вид»): аккаунт → что запускает → приветствие → если нет
  // подписки → что отдаём → дополнительные настройки. До этого весь разговор жил
  // одним длинным шагом «Настройка сообщений» с чертами внутри — на телефоне человек
  // мотал простыню и не находил ветку «если нет подписки». Один шаг = один вопрос.
  steps(locale: WizardLocale) {
    const ru = locale === 'ru';
    const T = TXT[locale];
    // СООБЩЕНИЯ БОТА — ОБЫЧНЫМИ ПОЛЯМИ, КАК У ИНСТАГРАМНОГО «ПОДАРКА» (К23.1 п.1,
    // владелец 07.09.2026): текст, кнопка, картинка и файл — каждое своим полем. Окно
    // «Сообщение» (`messages`/`wizMessageCards`) у этой анкеты не живёт: оно сделано для
    // цепочки писем и разовой рассылки, там и остаётся.
    return [
      // «О боте» первым у всех четырёх анкет (владелец 19.09.2026).
      aboutStep(locale, { title: ru ? 'Подарок за подписку' : 'Gift for a follow' }),
      {
        key: 'account',
        title: ru ? 'Бот' : 'Bot',
        // Что вообще делает бот, человек прочитал на шаге «Знакомство» (ТЗ-2 З1).
        intro: ru
          ? 'Выберите бота, в котором будет работать сценарий, и укажите, требуется ли подписка на канал.'
          : 'Select the bot for this scenario and specify whether a channel subscription is required.',
        params: [
          // Аккаунт — первым вопросом (Ф2, копия ChatPlace «Выберите аккаунт»). Вариантов
          // в анкете нет — их подставляет панель мастера из подключённых доступов канала.
          {
            name: 'accountId',
            type: 'options',
            required: true,
            default: '',
            displayName: ru ? 'Бот' : 'Bot',
            options: [],
          },
          // «Проверить подписку» — ПОСЛЕДНИМ, со своими полями (панель выделяет заливкой
          // всё от checkSub и ниже). Подпись КОРОТКАЯ, как у инста-сестры (владелец
          // 2026-08-06, Ч7): на какой канал — говорит подсказка под ней.
          {
            name: 'checkSub',
            type: 'boolean',
            required: true,
            default: true,
            displayName: ru ? 'Проверить подписку' : 'Require subscription',
            description: ru
              ? 'Бот отправит материал только после подписки на ваш канал'
              : 'The bot sends the material only to channel subscribers',
          },
          {
            name: 'subOnboard',
            type: 'notice',
            default: '',
            displayName: ru
              ? 'Добавьте бота администратором канала: откройте канал → нажмите название → «Администраторы» → «Добавить администратора» → выберите бота и включите все права, кроме добавления администраторов.'
              : 'Add the bot as a channel admin: open the channel → tap its name → “Administrators” → “Add administrator” → pick the bot and grant all rights except adding admins.',
            displayOptions: { show: { checkSub: [true] } },
          },
          // Поле канала панель рисует СВОИМ пикером (владелец 05.08): выбор из каналов,
          // где бот замечен (реестр bot_channels), или логин руками — с живой проверкой
          // «бот администратор?». Значение — адрес канала (@логин) или ссылка t.me.
          {
            name: 'channelLink',
            type: 'string',
            required: true,
            default: '',
            displayName: ru ? 'Канал' : 'Channel',
            placeholder: '@my_channel',
            description: ru
              ? 'Кнопка «Перейти в канал» ведёт сюда. У закрытого канала или группы бот сам возьмёт ссылку-приглашение.'
              : 'The “Open channel” button leads here. For a private channel or group the bot takes the invite link by itself.',
            displayOptions: { show: { checkSub: [true] } },
          },
        ],
      },
      // ЧТО ЗАПУСКАЕТ — ГАЛОЧКАМИ (ТЗ владельца 02.09.2026 §6): входов у бота может быть
      // сколько угодно, у каждого свои настройки. ЗАПУСК НЕЗАВИСИМ от проверки подписки
      // (заказ владельца 04.08): у ChatPlace выбор запуска прятался при включённой
      // подписке — у нас не прячется. Поля общие с мастером запуска Телеграма
      // (tgEntryKindParams в core): одинаковое зовётся и выглядит одинаково.
      triggerStep<BotEntry>(locale, {
        kinds: 'tg',
        key: TG_ENTRY_STEP,
        title: ru ? 'Что запускает' : 'What starts it',
        // ПОДВОДКА БЕЗ СЛОВА «ТРИГГЕР» (ТЗ USERTEST-1014 п.4, владелец 14.10.2026); хвост tgEntryStepHint вошёл в неё.
        intro: ru
          ? 'Укажите, с чего начинается разговор: пользователь нажал «Начать», отправил кодовое слово или перешёл по вашей ссылке. Можно добавить несколько вариантов — если подходят сразу несколько, сработает самый точный.'
          : 'Specify what starts the conversation: the user taps “Start”, sends a code word or opens your link. You can add several options — if several match at once, the most precise one is used.',
        store,
        chat: botTrigChat,
      }),
      {
        key: 'welcome',
        title: ru ? 'Приветствие' : 'Welcome',
        intro: ru
          ? 'Первое сообщение бота и кнопка, по которой пользователь получит обещанный материал.'
          : 'The first message from the bot and the button the user taps to receive the promised material.',
        params: [
          {
            name: 'welcomeText',
            type: 'string',
            required: true,
            default: T.welcome,
            typeOptions: { rows: 3 },
            displayName: ru ? 'Приветственное сообщение' : 'Welcome message',
            placeholder: ru ? 'Напишите сообщение' : 'Write a message',
          },
          {
            name: 'welcomeBtn',
            type: 'string',
            required: true,
            default: T.welcomeBtn,
            displayName: ru ? 'Текст в кнопке' : 'Button text',
            placeholder: ru ? 'Текст в кнопке' : 'Button text',
          },
          {
            // ЕДИНСТВЕННОЕ ПОЛЕ АНКЕТ, КОТОРОЕ МОЖНО ПРОПУСТИТЬ (владелец 08.09.2026,
            // Л1 п.8): у всех остальных стоит `required`, а слово «необязательно» убрано
            // из словаря целиком — вместе с ним ушёл и хвост подписи.
            name: 'welcomeImage',
            type: 'string',
            default: '',
            displayName: ru ? 'Картинка к приветствию' : 'Welcome image',
          },
        ],
      },
      {
        // Шаг сам исчезает, когда проверка подписки выключена: все его поля скрыты, а
        // такие шаги панель пропускает (template-wizard, фильтр по visibleParams).
        key: 'nosub',
        title: ru ? 'Если нет подписки' : 'If not subscribed',
        intro: ru
          ? 'Это сообщение получит пользователь, который нажал кнопку, но не подписан на канал.'
          : 'This message is shown to a user who tapped the button but is not subscribed to the channel.',
        params: [
          // «Если нет подписки» — расшито (владелец 04.08: раньше текст был зашит в
          // шаблон). Ветку называет ЗАГОЛОВОК ШАГА — у полей подписи простые.
          {
            name: 'noSubText',
            type: 'string',
            required: true,
            default: T.noSub,
            typeOptions: { rows: 3 },
            displayName: ru ? 'Сообщение' : 'Message',
            placeholder: ru ? 'Напишите сообщение' : 'Write a message',
            description: ru
              ? 'Отправляется, если пользователь нажал кнопку, но ещё не подписан'
              : 'Sent if the user tapped the button but has not subscribed yet',
            displayOptions: { show: { checkSub: [true] } },
          },
          {
            name: 'noSubBtn',
            type: 'string',
            required: true,
            default: T.noSubBtn,
            displayName: ru ? 'Текст в кнопке' : 'Button text',
            placeholder: T.noSubBtn,
            description: ru
              ? 'По этой кнопке бот повторно проверит подписку'
              : 'This button makes the bot check the subscription again',
            displayOptions: { show: { checkSub: [true] } },
          },
        ],
      },
      {
        key: 'gift',
        title: ru ? 'Что получит пользователь' : 'What the user receives',
        intro: ru
          ? 'Бот отправит этот материал после выполнения условий.'
          : 'The bot sends this material once the conditions are met.',
        params: [
          {
            name: 'linkText',
            type: 'string',
            required: true,
            default: T.link,
            typeOptions: { rows: 3 },
            displayName: ru ? 'Сообщение' : 'Message',
            placeholder: ru ? 'Напишите сообщение' : 'Write a message',
          },
          // Обещанное можно отдать не только ссылкой (заказ владельца): ссылка / картинка /
          // видео / аудио / файл — ровно то, что умеет шаг «Сообщение» в схеме. Виды
          // берутся у канала; кнопка со ссылкой живёт только у ссылки.
          wizGiftKindParam('telegram', locale),
          {
            name: 'linkBtn',
            type: 'string',
            required: true,
            default: T.linkBtn,
            displayName: ru ? 'Текст в кнопке' : 'Button text',
            placeholder: ru ? 'Текст в кнопке' : 'Button text',
            displayOptions: { show: { [WIZ_GIFT_KIND]: [WIZ_GIFT_LINK] } },
          },
          {
            name: 'linkUrl',
            type: 'string',
            required: true,
            default: '',
            displayName: ru ? 'Ссылка' : 'Link',
            placeholder: 'https://…',
            description: ru
              ? 'Открывается по кнопке в сообщении'
              : 'Opens from the button in the message',
            displayOptions: { show: { [WIZ_GIFT_KIND]: [WIZ_GIFT_LINK] } },
          },
          wizGiftFileParam('telegram', locale),
        ],
      },
      {
        key: 'additional',
        title: ru ? 'Дополнительные настройки' : 'Additional settings',
        intro: ru
          ? 'Напоминание тем, кто не нажал кнопку, и дополнительное сообщение после выдачи материала.'
          : 'A reminder for users who did not tap the button, and a follow-up message after the material is delivered.',
        params: [
          {
            name: 'remind',
            type: 'boolean',
            required: true,
            default: false,
            // Подпись и подсказка — как у инста-сестры и в одну строку (владелец 20.09.2026:
            // «напомнить перейти по ссылке — неверная формулировка»).
            displayName: ru ? 'Напомнить про подарок' : 'Remind about the gift',
            description: ru ? 'Отправится через 10 минут' : 'Sent after 10 minutes',
          },
          {
            name: 'remindText',
            type: 'string',
            required: true,
            default: T.remind,
            typeOptions: { rows: 3 },
            displayName: ru ? 'Текст напоминания' : 'Reminder text',
            placeholder: ru ? 'Напишите сообщение' : 'Write a message',
            displayOptions: { show: { remind: [true] } },
          },
          {
            name: 'extra',
            type: 'boolean',
            required: true,
            default: false,
            displayName: ru ? 'Дополнительное сообщение' : 'Follow-up message',
            description: ru
              ? 'Отправляется через указанное количество минут после выдачи материала'
              : 'Sent the specified number of minutes after the material is delivered',
          },
          {
            name: 'extraText',
            type: 'string',
            required: true,
            // ПРИМЕР ПО УМОЛЧАНИЮ (ТЗ USERTEST-1014 п.8, владелец 14.10.2026).
            default: EXTRA_TEXT_SAMPLE[locale],
            typeOptions: { rows: 2 },
            displayName: ru ? 'Сообщение' : 'Message',
            placeholder: ru ? 'Сообщение или ссылка' : 'Message or link',
            displayOptions: { show: { extra: [true] } },
          },
          {
            name: 'extraMinutes',
            type: 'number',
            required: true,
            default: 10,
            typeOptions: { minValue: 1, maxValue: 10080 },
            displayName: ru ? 'Интервал, минут' : 'Interval, minutes',
            displayOptions: { show: { extra: [true] } },
          },
          // СРОК БОТА — ПОСЛЕДНИМ ПОЛЕМ (владелец 08.09.2026, Л1 п.5): пока человек
          // внутри бота, все его сообщения идут этому боту, и отпускает его только конец
          // сценария или молчание дольше этого срока. В базе это `holdTimeoutMin`.
          {
            name: 'finishHours',
            type: 'number',
            required: true,
            default: 24,
            typeOptions: { minValue: 1, maxValue: 720 },
            displayName: ru ? 'Завершать разговор через (часов)' : 'Finish the conversation after (hours)',
            description: ru
              ? 'Разговор считается завершённым, когда цель бота достигнута или пользователь молчит дольше указанного времени. Пока пользователь отвечает этому боту, другие боты ему не пишут — иначе путаница.'
              : 'The conversation counts as finished when the bot has reached its goal or the user stays silent longer than this. While the user is replying to this bot, other bots do not write to them — otherwise it gets confusing.',
          },
          // «НЕ ЗАПУСКАТЬ ПОВТОРНО» — САМЫМИ ПОСЛЕДНИМИ ПОЛЯМИ (владелец 09.09.2026,
          // Л5.1 п.1): выключено по умолчанию, включили — следующие N дней сообщения
          // этого человека бота не запускают. В черновике это `antiRepeatMin` (МИНУТЫ).
          {
            name: 'noRepeat',
            type: 'boolean',
            required: true,
            default: false,
            displayName: ru ? 'Не запускать повторно' : 'Do not start again',
            description: ru
              ? 'Тот, кто уже запускал бота, не запустит его снова своими сообщениями и комментариями в течение указанного числа дней'
              : 'Someone who has already started the bot cannot start it again with their messages or comments for the specified number of days',
          },
          {
            name: 'noRepeatDays',
            type: 'number',
            required: true,
            default: 30,
            typeOptions: { minValue: 1, maxValue: 365 },
            displayName: ru ? 'дней' : 'days',
            displayOptions: { show: { noRepeat: [true] } },
          },
        ],
      },
    ];
  },

  // ФРАЗЫ ЭТОГО БОТА В ТЕЛЕФОНЕ ПЕРВОГО ЭКРАНА (ТЗ-7 Ш3). Сцена «Подарок за подписку»
  // в Телеграме (s4): из анкеты в неё встают приветствие, кнопка и то, что бот отдаёт;
  // поста и комментариев у этой сцены нет вовсе.
  sceneTexts(answers, locale) {
    const a = readAnswers(answers, locale);
    const out: SceneTexts = {};
    if (a.welcomeText) out.reply = a.welcomeText;
    if (a.welcomeBtn) out.chip = a.welcomeBtn;
    if (a.linkText) out.give = a.linkText;
    // ПОДАРОК ССЫЛКОЙ (Д7): вложения нет — карточку файла из копии сцены убираем меткой,
    // иначе на её месте останется имя подарка ниши, которого этот бот не отправляет.
    const file = wizFileName(a.gift.file);
    out.file = file || SCENE_NO_FILE;
    // ОПИСАНИЕ БОТА НА ТЕЛЕГРАМНОЙ ЗАСТАВКЕ (Д8): своё, а не нишевое. Карточка «что
    // умеет бот» стоит прямо над приветствием, и обещать в ней одно, а в приветствии
    // другое — нельзя. Берём первую фразу приветствия, а нет его — текст выдачи.
    const about = firstSentence(a.welcomeText) || firstSentence(a.linkText);
    if (about) out.about = about;
    return out;
  },

  preview(answers, stepIdx, locale) {
    const a = readAnswers(answers, locale);
    const T = TXT[locale];
    // Телефон показывает ОДИН разговор: рисуем ПЕРВЫЙ по своду отмеченный вход
    // (start, link, exact, keyword, any) — у слов это само слово, у остальных «/start».
    const first = a.entries[0];
    const firstKind = first?.kind ?? 'start';
    const userStart =
      firstKind === 'exact' || firstKind === 'keyword' ? (first?.keywords[0] ?? '') : '/start';
    // Шаг «Дополнительные настройки» стоит последним — напоминание и догрев в превью
    // показываем с него и дальше (сам индекс считается по СВОИМ шагам дефа).
    // Индексы шагов: 0 — «О боте», 1 — бот (19.09.2026).
    if (stepIdx <= 1) {
      if (!userStart) {
        return [
          {
            from: 'bot',
            text:
              locale === 'ru'
                ? 'Здесь показано, как чат-бот общается с клиентом'
                : 'This shows how the bot talks to a client',
          },
        ];
      }
      return [{ from: 'user', text: userStart }];
    }
    const msgs: WizardPreviewMsg[] = [];
    if (userStart) msgs.push({ from: 'user', text: userStart });
    msgs.push({
      from: 'bot',
      text: a.welcomeText,
      buttons: [a.welcomeBtn, ...(a.checkSub ? [T.channelBtn] : [])],
      ...(a.welcomeImage ? { imageUrl: a.welcomeImage } : {}),
    });
    msgs.push({ from: 'user', text: a.welcomeBtn });
    // С проверкой подписки превью показывает и дожим: нажал кнопку без подписки →
    // «Если нет подписки» → подписался, нажал повторную проверку → выдача.
    if (a.checkSub) {
      msgs.push({ from: 'bot', text: a.noSubText, buttons: [a.noSubBtn] });
      msgs.push({ from: 'user', text: a.noSubBtn });
    }
    // Вложение уходит ОТДЕЛЬНЫМ сообщением (у мессенджера файл — своё сообщение),
    // кнопка со ссылкой при этом не нужна.
    if (a.gift.kind === WIZ_GIFT_LINK) {
      msgs.push({ from: 'bot', text: a.linkText, buttons: [a.linkBtn] });
    } else {
      msgs.push({ from: 'bot', text: a.linkText });
      msgs.push({ from: 'bot', text: '', attach: { kind: a.gift.kind, url: a.gift.file } });
    }
    if (stepIdx >= 3) {
      if (a.remind) msgs.push({ from: 'bot', text: a.remindText });
      if (ansBool(answers, 'extra')) {
        msgs.push({
          from: 'bot',
          text: a.extraText || T.nExtra,
        });
      }
    }
    return msgs;
  },

  buildWorkflow(
    template: WorkflowJson,
    answers: Record<string, unknown>,
    locale: WizardLocale,
    extras: WizardBuildExtras = {},
  ): WorkflowJson {
    const a = readAnswers(answers, locale);
    const T = TXT[locale];
    let wf = template;

    // Приветствие: текст, кнопка выдачи; при проверке подписки — вторая кнопка в канал.
    // Канал из пикера приходит адресом (@логин) — кнопке нужен URL.
    //
    // АДРЕСА НЕТ — НЕТ И КНОПКИ (К27.6 п.2, аудит 08.09 п.8). У приватного канала человек
    // вписывает числовой id вида -100…: подставленный кнопке, он не адрес, и Телеграм
    // отвергает ОТПРАВКУ ЦЕЛИКОМ (BUTTON_URL_INVALID) — бот молчит с первого сообщения.
    // Заглушка «[ссылка]» была ровно тем же битым адресом. Понятны три написания: «@логин»
    // (собираем ссылку t.me), готовая ссылка http(s) (как есть) и всё остальное — пусто.
    // ЛЮБОЕ ГОДНОЕ НАПИСАНИЕ ДАЁТ КНОПКУ (ТЗ 19.09.2026 Р7): адрес разбирает тот же
    // `tgChatId`, которым живёт сама проверка подписки, — «@логин», голый «логин»,
    // «t.me/логин» и «https://t.me/логин/» сводятся к одному «@логин», и ссылка кнопки
    // собирается из него. Прежний разбор понимал только «@логин» и готовую http-ссылку:
    // человек, написавший логин без собаки (в приложении это обычное дело), получал бота
    // БЕЗ кнопки «Перейти в канал». Числовой адрес приватного канала кнопки не даёт —
    // подставленный в url, он валит ОТПРАВКУ целиком (BUTTON_URL_INVALID, К27.6 п.2).
    // ЗАКРЫТЫЙ КАНАЛ ИЛИ ГРУППА (ТЗ CHAN-ADD 16.10.2026): адрес — числовой id, а ссылку-приглашение бот-администратор
    // берёт у Telegram сам, её приносит сервер (`extras.channelInvite`). Флоу один для открытого и закрытого — клиент
    // ничего не вписывает. Ссылки нет (боту не дали права приглашать) — кнопки нет, как и раньше.
    const channelChat = tgChatId(a.channelLink);
    const invite = /^https:\/\/t\.me\/\S+$/.test(extras.channelInvite ?? '') ? (extras.channelInvite as string) : '';
    const channelUrl = channelChat.startsWith('@') ? `https://t.me/${channelChat.slice(1)}` : invite;
    wf = wfTgMessage(
      wf,
      N.welcome,
      wizBundle(
        a.welcomeText,
        [
          { text: a.welcomeBtn },
          ...(a.checkSub && channelUrl !== '' ? [{ text: T.channelBtn, url: channelUrl }] : []),
        ],
        // Картинка приветствия — В ЭТОМ ЖЕ сообщении (владелец 20.09.2026: «картинка
        // приехала отдельно от кнопок»); прежний отдельный узел «Картинка к приветствию»
        // перед текстом снят.
        a.welcomeImage || undefined,
      ),
      't-welcome-btn',
    );
    // ОБЕ РАЗВИЛКИ «КАКУЮ КНОПКУ НАЖАЛ?» ВЫБРАСЫВАЮТСЯ ВСЕГДА (К26.2 п.3, аудит 08.09).
    // Они сравнивали `$json.pressedButton` — поле, которого не пишет ни один наш узел:
    // не совпадала ни одна ветка, подарок по кнопке не выдавался, а «без ответа 10 мин»
    // на их запасном выходе слало напоминание даже тем, кто уже всё забрал. Нажатие
    // приходит НОВЫМ запуском сценария и разбирается первой пилюлей развилки входящего.
    wf = wfDropNodes(wf, [N.welcomeSwitch, N.noSubSwitch]);

    // МАТЕРИАЛ ОТДАЁТСЯ ЗАНОВО, БЕЗ РАЗГОВОРОВ (владелец 20.09.2026: «убери, она тупая»).
    // Реплики вернувшемуся («мы уже общались, всё выше в этом чате») в схеме нет вовсе:
    // человек попросил подарок — бот молча отдаёт его ещё раз. Узел канона выбрасываем.
    wf = wfDropNodes(wf, [N.repeat]);

    // Сообщение со ссылкой — или сообщение + вложение следом (заказ владельца: обещанное
    // отдаём ссылкой, картинкой, видео, аудио или файлом).
    if (a.gift.kind === WIZ_GIFT_LINK) {
      wf = wfTgMessage(wf, N.link, wizBundle(a.linkText, [{ text: a.linkBtn, url: a.linkUrl || T.linkStub }]));
    } else {
      // ВЛОЖЕНИЕ И ТЕКСТ — ОДНИМ СООБЩЕНИЕМ (владелец 20.09.2026): ролик/звук/документ/
      // картинка с подписью, как шлёт любой бот Телеграма. Отдельный шаг «файл следом»
      // (стандартный узел Telegram) снят: он и слал вторым пузырём, и в ленту записывался
      // без файла (площадка не отдаёт getFile тяжелее 20 МБ). Наш узел шлёт байтами из
      // хранилища (повторно — по file_id) и пишет в ленту наш же адрес.
      wf = wfTgMessage(wf, N.link, wizBundle(a.linkText, [], undefined, { kind: a.gift.kind, url: a.gift.file }));
    }

    // ЦЕЛЬ БОТА — НАСТОЯЩИЙ ШАГ-МЕТКА (К26.2 п.4, аудит 08.09 п.7). В каноне шаблона на
    // этом месте стоял `set` «Записать: метка + прошёл воронку» — он ничего не писал в
    // карточку человека: метки цели не появлялось, «дошёл до цели» не считалось нигде, и
    // вход цепочки «прошёл Telegram-подарок, дошёл до цели» не срабатывал никогда.
    // Ставим тот же узел «Контакты», что у инстаграмных анкет.
    wf = wfSetType(wf, N.setTag, 'CUSTOM.scripteraContacts', 1);
    wf = wfUnsetParams(wf, N.setTag, ['assignments', 'options']);
    wf = wfSetParams(wf, N.setTag, {
      operation: 'addTags',
      tags: T.giftTag,
      source: 'manual',
      channel: 'telegram',
      externalId: CHAT_ID,
    });
    wf = wfSetNotes(wf, N.setTag, T.noteGotTag);
    wf = wfRenameNode(wf, N.setTag, T.nGotTag);

    // «Запомнить контакт» — вторым шагом, сразу за запуском (как у инста-сестры): без
    // карточки человека метку ставить не на что, а рассылки не находят получателя.
    wf = wfInsertAfter(
      wf,
      N.start,
      contactNode('wiz-remember', T.nRemember, T.noteRemember, {
        operation: 'save',
        name: NAME_EXPR,
        username: USERNAME_EXPR,
      }),
    );

    // ПРОВЕРКИ «ПОДАРОК УЖЕ ВЫДАВАЛИ?» БОЛЬШЕ НЕТ (владелец 20.09.2026). До этого дня перед
    // меткой стояла пара «смотрим карточку — метка есть, молчим/отвечаем „мы уже общались“»:
    // человек нажимал «Да, хочу» и вместо материала получал отговорку (а метка могла остаться
    // и от прошлого бота на том же аккаунте). Решение владельца: попросил — отдаём ещё раз,
    // проверки «получал ли уже» на пути ПРОСЬБЫ не существует. Метка «получил подарок»
    // остаётся — по ней считается «дошёл до цели», по ней напоминание обходит тех, кто всё
    // забрал, и по ней же (с 16.10.2026) запасной выход развилки входящего молчит
    // получившему на случайный текст.

    // «УЖЕ ПОЛУЧИЛ?» НА ЗАПАСНОМ ВЫХОДЕ (владелец 16.10.2026, ТЗ GIFT-REPEAT). Решение
    // 20.09 («попросил — отдаём ещё раз») не отменено, а уточнено: просьба — это кнопка,
    // кодовое слово, /start; случайный текст внутри разговора («спасибо») — не просьба.
    // Пара та же, что у напоминания ниже, вторым экземпляром.
    const gate = gotGateTexts(locale);
    const gotGate = (target: string) =>
      wfGotGate(wf, {
        check: contactNode('wiz-got-check-in', gate.nCheck, gate.noteCheck, {
          operation: 'check',
          checkMode: 'any',
          tags: T.giftTag,
        }),
        ifId: 'wiz-got-if-in',
        ifName: gate.nIf,
        target,
      });

    // Проверка подписки выключена → ветка подписки выбрасывается, кнопка ведёт сразу к выдаче.
    if (!a.checkSub) {
      wf = wfDropNodes(wf, [N.condSub, N.noSub]);
      // ПЕРВАЯ РАЗВИЛКА собирается так же, как с проверкой подписки: разбором ВХОДЯЩЕГО.
      // В каноне шаблона на этом месте лежит заготовка — разбор поля `branch`, которого
      // никто не ставит, и без запасного выхода: не совпадала НИ ОДНА ветка, и бот молчал
      // с первого же сообщения (та же болезнь, что вылечили у проверки подписки 11.08).
      // Ветки заготовки остаются на своих местах, к ним добавилась ветка нажатия кнопки.
      wf = wfSetParams(wf, N.condTag, wizSwitchParams([pressPill(T), entryPill(a, T)], T.outOther));
      // Нажал кнопку → метка и выдача (владелец 20.09.2026: «отдавать материал ещё раз,
      // просто и всё»); начало разговора → приветствие; всё остальное — «Уже получил?»:
      // получил — бот молчит, нет — та же дорога выдачи (владелец 16.10.2026).
      wf = gotGate(T.nGotTag);
      wf = wfSetOuts(wf, N.condTag, [T.nGotTag, N.welcome, gate.nCheck]);
      wf = wfSetNotes(wf, N.condTag, T.noteEntry);
      wf = wfRenameNode(wf, N.condTag, T.nEntry);
    } else {
      // ЛЮБОЕ СООБЩЕНИЕ ЗАНОВО ПРОВЕРЯЕТ ПОДПИСКУ (владелец 2026-08-07, то же правило,
      // что у инста-сестры). Первая развилка после «Старта» перестаёт быть проверкой
      // метки «прошёл воронку» (её нечем ставить — в схеме на этом месте заготовка) и
      // становится разбором ВХОДЯЩЕГО: начало разговора ведёт к приветствию, а нажатие
      // кнопки и любое другое сообщение — на проверку подписки. Дойти сюда «любым
      // другим» может только тот, кто уже в воронке: диспетчер отдаёт сценарию чужой
      // текст лишь по замку «Работать без прерывания» (holdDialog в triggerMeta ниже).
      wf = wfSetParams(wf, N.condTag, wizSwitchParams([pressPill(T), entryPill(a, T)], T.outOther));
      // Нажал кнопку («Да, хочу» или «Готово») → проверка подписки; начало разговора →
      // приветствие; всё остальное — снова проверка. Шаг проверки встаёт перед развилкой
      // ниже (wfInsertBefore), и обе эти связи перевешиваются на него сами.
      // Запасной выход — сперва «Уже получил?» (владелец 16.10.2026): получивший на
      // случайный текст слышит тишину, не получивший идёт на проверку подписки, как раньше.
      // Цель «нет» пары — сама развилка подписки: шаг проверки ниже встанет и перед ней.
      wf = gotGate(N.condSub);
      wf = wfSetOuts(wf, N.condTag, [N.condSub, N.welcome, gate.nCheck]);
      wf = wfSetNotes(wf, N.condTag, T.noteEntry);
      wf = wfRenameNode(wf, N.condTag, T.nEntry);
      // «Если нет подписки» — текст и кнопка из анкеты (расшито 04.08). Исходящих связей
      // у этого шага нет вовсе: нажатие «Готово» придёт НОВЫМ запуском и попадёт в первую
      // пилюлю развилки входящего, а та снова отправит человека на проверку подписки.
      wf = wfTgMessage(wf, N.noSub, wizBundle(a.noSubText, [{ text: a.noSubBtn }]), 't-nosub-btn');

      // САМА ПРОВЕРКА ПОДПИСКИ (боевая находка 2026-08-11: её тут не было вовсе).
      // В каноне шаблона на этом месте лежит развилка-ЗАГОТОВКА: она разбирает поле
      // `branch`, которого никто не ставит, — после «Да, хочу» не совпадала ни одна ветка
      // и бот просто замолкал, подарок не выдавался. Собираем так же, как у живого
      // шаблона «Подписка на канал» и у инста-сестры: шаг спрашивает у Телеграма, кем
      // человек приходится каналу, а развилка читает ответ формулой.
      //
      // Шаг встаёт ПЕРЕД развилкой, и все входящие связи перевешиваются на него
      // (wfInsertBefore): к развилке ведут два пути — нажатие кнопки и любое другое
      // сообщение, — и каждый обязан проверять подписку ЗАНОВО.
      wf = wfInsertBefore(wf, N.condSub, {
        id: 'wiz-sub-check',
        name: T.nSubCheck,
        type: 'n8n-nodes-base.telegram',
        typeVersion: 1.2,
        position: [0, 0],
        parameters: {
          resource: 'chat',
          operation: 'member',
          chatId: tgChatId(a.channelLink),
          userId: FROM_ID,
        },
        notes: T.noteSubCheck,
      });
      // Заготовка была разбором значения, настоящая проверка — «Если» с формулой: только
      // его кабинет читает человеческим рядом «Подписан» и прячет шаг-проверку внутрь
      // карточки (иначе клиент увидел бы нашу кухню отдельным шагом). Выходы те же:
      // первый — подписан, второй — нет.
      wf = wfSetType(wf, N.condSub, 'n8n-nodes-base.if', 2.2);
      wf = wfUnsetParams(wf, N.condSub, ['rules', 'options']);
      wf = wfSetParams(wf, N.condSub, {
        conditions: {
          options: { version: 2, caseSensitive: true, typeValidation: 'loose' },
          combinator: 'and',
          conditions: [
            {
              id: 'c-cond-0',
              operator: { type: 'boolean', operation: 'true', singleValue: true },
              leftValue: `={{ ${tgSubscribedExpr(`$('${T.nSubCheck}').first().json`)} }}`,
              rightValue: '',
            },
          ],
        },
        looseTypeValidation: true,
      });
    }

    // НАПОМИНАНИЕ ОБХОДИТ ТЕХ, КТО УЖЕ ЗАБРАЛ ПОДАРОК (К26.2 п.3, аудит 08.09 п.2).
    // До 08.09 «Без ответа 10 мин» висело на запасном выходе развилки «Какую кнопку
    // нажал?», которая не совпадала никогда, — «я всё жду, когда ты нажмёшь кнопку»
    // получал и тот, кто подарок уже получил. Ставим ту же защиту, что в
    // инстаграмном каноне: ждём десять минут, смотрим метку и молчим, если она есть.
    if (!a.remind) wf = wfDropNodes(wf, [N.wait10, N.remindMsg]);
    else {
      wf = wfTgMessage(wf, N.remindMsg, wizBundle(a.remindText));
      // Отсчёт идёт от приветствия: развилки кнопок между ними больше нет.
      wf = wfConnect(wf, N.welcome, 0, N.wait10);
      wf = wfInsertBefore(
        wf,
        N.remindMsg,
        contactNode('wiz-got-check', T.nGotCheck, T.noteGotCheck, {
          operation: 'check',
          checkMode: 'any',
          tags: T.giftTag,
        }),
      );
      wf = wfInsertBefore(wf, N.remindMsg, {
        id: 'wiz-got-if',
        name: T.nGotIf,
        type: 'n8n-nodes-base.if',
        typeVersion: 2.2,
        position: [0, 0],
        // Подписи у карточки условия нет НАРОЧНО (CONDITIONS У0): её собирает из рядов
        // сам кабинет, а рукописная устаревает в тот миг, когда человек поправил ряд.
        parameters: {
          conditions: {
            options: { version: 2, caseSensitive: true, typeValidation: 'loose' },
            combinator: 'and',
            conditions: [
              {
                id: 'got-if-0',
                operator: { type: 'boolean', operation: 'true', singleValue: true },
                leftValue: `={{ $('${T.nGotCheck}').first().json.passed === true }}`,
                rightValue: '',
              },
            ],
          },
          looseTypeValidation: true,
        },
      });
      // Подарок уже у человека — молчим (выход «да» пустой); нет — напоминаем.
      wf = wfSetOuts(wf, T.nGotIf, [null, N.remindMsg]);
    }

    // Дополнительное сообщение (шаг 3, тумблер 2).
    if (!a.extra) wf = wfDropNodes(wf, [N.wait15, N.extraMsg]);
    else {
      wf = wfSetParams(wf, N.wait15, { amount: a.extraMinutes });
      wf = wfTgMessage(wf, N.extraMsg, wizBundle(a.extraText));
    }

    // Кодовое слово фильтрует ДИСПЕТЧЕР по условиям запуска черновика (triggerMeta ниже) —
    // внутренний узел-фильтр убран 04.08: он был мёртвым грузом, потому что до него
    // недобранное слово просто не долетало (а при triggerKind шаблона не долетало ничего).

    // «Метки запустившему» больше нет (владелец 05.08 №3: поле убрано из анкеты).

    // Картинка приветствия едет ВНУТРИ сообщения приветствия (wizBundle выше), отдельного
    // узла перед текстом больше нет (владелец 20.09.2026).

    // Имена узлов-сообщений — по новым текстам (как режет конвейер переносов).
    const taken = new Set(wf.nodes.map((n) => n.name));
    const renames: Array<[string, string]> = [];
    const plan = (oldName: string, text: string, fallback: string) => {
      if (!wf.nodes.some((n) => n.name === oldName)) return;
      taken.delete(oldName);
      const next = wizNodeTitle(text, taken, fallback);
      if (next !== oldName) renames.push([oldName, next]);
    };
    plan(N.welcome, a.welcomeText, T.nWelcome);
    if (a.checkSub) plan(N.noSub, a.noSubText, T.nNoSub);
    plan(N.link, a.linkText, T.nLink);
    if (a.remind) plan(N.remindMsg, a.remindText, T.nRemind);
    if (a.extra) {
      plan(N.wait15, T.nDelayMin(a.extraMinutes), T.nDelay);
      plan(N.extraMsg, a.extraText, T.nExtra);
    }
    for (const [oldName, next] of renames) wf = wfRenameNode(wf, oldName, next);

    return wf;
  },

  // Условия запуска черновика — из ответов (без этого выбор в анкете не доезжал до
  // диспетчера: черновик копировал условия карточки шаблона).
  triggerMeta(answers, locale) {
    const a = readAnswers(answers, locale);
    // ВХОДЫ БОТА (ТЗ 02.09 §6): по строке на каждую отмеченную галочку; порядок и
    // разбор — общий кусок обеих телеграм-анкет (tgEntriesOf в core).
    // ЗАМОК ДИАЛОГА — НЕ ВЫБОР, А ЗАКОН (владелец 08.09.2026, Л1 п.5; прежде включался
    // только вместе с проверкой подписки). Пока человек внутри бота, ВСЁ его входящее
    // идёт этому боту: чужое слово, «любое», кнопки, «/start». Отпускает его конец
    // сценария или молчание дольше срока из анкеты (`finishHours` → минуты).
    const hold = { holdDialog: true, holdTimeoutMin: a.finishHours * 60 };
    // «Не запускать повторно» (владелец 09.09.2026, Л5.1 п.1): дни анкеты — минуты
    // черновика; выключено — ровно 0, иначе прежний запрет остался бы жить.
    const antiRepeatMin = a.noRepeat ? a.noRepeatDays * 1440 : 0;
    return { entries: a.entries, ...hold, antiRepeatMin };
  },

  // ЧЕРНОВИК, СОХРАНЁННЫЙ ОКНОМ «СООБЩЕНИЕ» (03.09–07.09.2026), ОТКРЫВАЕТСЯ ПЛОСКИМ
  // (К23.1 п.1): панель читает ответы этой дверью — тексты встают в поля, а связки из
  // ответов уходят и назад не пишутся.
  adoptAnswers: tgFlatAnswers,

  // ПОЛОВИНЧАТЫЙ ТРИГГЕР НЕ ПУСКАЕТ ДАЛЬШЕ (К18.3 этап 2 п.1): слова и подпись источника
  // живут на СВОЕЙ странице, обязательность поля шага их больше не ловит.
  stepBlocked(answers, stepKey, locale, live) {
    // ШАГ «БОТ»: канал обязан быть ПРОВЕРЕННЫМ (ТЗ 19.09.2026 Р4). Пока идёт проверка и
    // при определённом отказе площадки «Дальше» не пускает — тем же текстом, который
    // человек видит у поля. Пустой канал сюда не относится: про него говорит обычное
    // «Заполните поле» шага (поле `channelLink` обязательное).
    if (stepKey === TG_BOT_STEP) {
      const a = readAnswers(answers, locale);
      if (!a.checkSub || a.channelLink.trim() === '') return null;
      const ch = live?.channel;
      if (!ch || ch.phase === 'ok') return null;
      if (ch.phase === 'checking') return ch.text || null;
      return CHAN_HOLD.has(ch.reason ?? '') ? ch.text || null : null;
    }
    if (stepKey !== TG_ENTRY_STEP) return null;
    const list = store.read(answers);
    if (list.length === 0) return wizEntryWords(locale).empty;
    return trigBlocked('tg', locale, list, answers);
  },
};
